<template>
  <div class="index">
    <h2>《医学影像诊断学》第五版</h2>
    <div class="btn-box">
      <tab-button
        :showAll="false"
        :tabs="professionData"
        :label="''"
        :name="'dictionaryName'"
        :prop="'type'"
        :initialTab="professionId"
        @tab-change="onTabChange"
      />
      <span type="text" @click="selectTree" class="select-ml">选择课程目录</span>
    </div>
    <div class="block departStructure" v-if="data.length">
      <!-- <el-tree id="tree"
        v-loading="loading"
        ref="tree"
        :data="data"
        node-key="id"
        :highlight-current="true"
        :expand-on-click-node="false"
        :indent="30"
        :filter-node-method="filterNode"
        :accordion="true"
        :props="{
          label: 'name',
          children: 'subList'
        }"
        @node-click="nodeClick"
        :default-expanded-keys="defaultExpandIds"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="level-path">{{data.levelPath}}</span>
          <el-input
            v-model="data.name"
            style="width:50%"
            placeholder="请输入"
            class="k v-check"
            size="medium"
            v-checkParams="'required'"
            @focu="dragNode=false"
            @keyup.enter.native="$event.target.blur()"
            @blur.stop="submit(data, node)"
            maxlength="100"
            show-word-limit
          ></el-input>
          <span style="margin-left:20px;margin-top: 5px;">
            <el-button type="text" size="mini" @click="() => append(data, node)" v-if="canAddChild(data, node)">增加子目录</el-button>
            <el-button type="text" size="mini" @click="() => remove(node, data,'org_depart')">删除</el-button>
          </span>
        </span>
      </el-tree> -->
      <el-tree
        ref="tree"
        :data="data"
        node-key="id"
        :highlight-current="false"
        :expand-on-click-node="false"
        :indent="30"
        :accordion="true"
        :props="{
            label: 'name',
            children: 'subList'
        }"
        >
        <div class="custom-tree-node" slot-scope="{ node, data }">
            <div style="display: flex">
            <span class="level-path">{{data.levelPath}}</span>
            <span style="margin-left: 5px;display: inline-block;">{{data.name}}</span>
            </div>
        </div>
      </el-tree>
      <!-- <div>
        <el-button type="text" size="medium" @click="appendSame" icon="el-icon-edit">新建章节名称</el-button>
      </div> -->
    </div>
    <div v-else class="content">
      <el-empty description="暂无数据"></el-empty>
    </div>
    <tree ref="tree" v-if="dialogtree" @update="selectData"
    :data="data" :allTreeData="allTreeData" :dialogtree.sync="dialogtree" :professionId="professionId" />
  </div>
</template>

<script>
import deepCopy from '@/utils/deepcopy'
import { courseServer, keyServer } from '@/api/api'
import tabButton from '@/mixin/tabButton.js';
import tree from './tree.vue'
let treeid = 1000;
export default {
  mixins: [tabButton],
  components: {tree},
  data () {
    const data = [];
    return {
      data: JSON.parse(JSON.stringify(data)),
      allTreeData: [],
      professionData: [],
      professionId: '',
      professionName: '',
      loading: false,
      defaultExpandIds: [],  // 用于记录展开的节点
      dialogtree: false
    }
  },
  mounted () {
    this.initData()
    this.selectDataV2()
  },
  methods: {
    async initData() {
      try {
        await this.selectDataV1();
        this.selectData();
      } catch (error) {
        console.error('数据初始化失败:', error);
      }
    },
    selectData () {
      return new Promise((resolve, reject) => {
        courseServer.courseDirectoryList({
          professionId: this.professionId
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.data = data
          } else {
            this.$message.error(message)
          }
          resolve(res)
        }).catch((error) => {
          this.$message.error(error)
        })
      })
    },
    // 专业数据
    selectDataV1 () {
      return new Promise((resolve, reject) => {
        keyServer.profession({
          dictionaryKey: 'profession'
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.professionData = data
            this.professionId = this.professionData[0].id
            this.professionName = this.professionData[0].dictionaryName
            resolve();
          } else {
            this.$message.error(message)
            reject(new Error(message));
          }
        }).catch((error) => {
          this.$message.error(error)
          reject(error);
        })
      });
    },
    // 全局课程目录
    selectDataV2 () {
      this.data = []
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.allTreeData = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    submit (data, node) {
      if (!data.name) {
        this.$message.error('请填写内容！')
        return
      }
      if (data.id) {
        courseServer.courseDirectoryUpdate({
          id: data.id,
          name: data.name
        }).then(res => {
          const {code, message} = res
          if (code === '0') {
            this.selectData()
            this.$message.success('修改成功')
          } else {
            this.$message.error(message)
          }
        }).catch((error) => {
          this.loading = false
          this.$message.error(error)
        })
        return
      }
      courseServer.courseDirectoryAdd({
        parentId: data.parentId,
        levelPath: data.levelPath,
        name: data.name,
        sortOrder: data.sort
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.selectData()
          this.defaultExpandIds.push(data)
          this.$message.success('添加成功')
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.loading = false
        this.$message.error(error)
      })
    },
    // 增加同级
    appendSame () {
      this.data.push(
        {
          levelPath: this.data.length + 1,
          treeid: treeid++,
          sort: this.data.length + 1,
          level: 1,
          name: '',
          subList: []
        }
      )
    },
    // 增加子集
    append (data, node) {
      console.log(data, '===')
      node.expanded = true // 点击增加时器官树展开
      const newChild = {
        parentId: data.id,
        treeid: treeid++,
        name: '',
        sort: data.subList.length > 0 ? data.subList.length + 1 : 1,
        level: node.level + 1,
        subList: []
      };
      if (!data.subList) {
        this.$set(data, 'subList', []);
      }
      data.subList.push(newChild);
      this.indexData(this.data)
    },
    remove (node, data, dictionaryKey) {
      const parent = node.parent;
      let subList = [];
      let index = 0;
      if (!data.id) {
        if (data.level === 1) {
          subList = parent.data
        } else {
          subList = parent.data.subList
        }
        index = subList.findIndex(d => d.treeid === data.treeid)
        subList.splice(index, 1)
        return
      }
      const str = '请确认是否删除该菜单内容？'
      this.$confirm(str, '提示', { type: 'warning' }).then(
        () => {
          courseServer.courseDirectoryRemove({
            id: data.id
          }).then(res => {
            const {code, message} = res
            if (code === '0') {
              subList.splice(index, 1);
              this.$refs.tree.filter();
              this.batchUpdate()
            } else {
              this.$message.error(message)
            }
          }).catch((error) => {
            this.$message.error(error)
          });
        }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 批量更新
    async batchUpdate () {
      await this.selectData()
      this.indexData(this.data)
      let funcConfig = []
      let arr = this.data
      console.log(arr, 'aa')
      if (Array.isArray(arr)) {
        funcConfig = this.returnResult(arr).map(v => {
          return { id: v.id,  levelPath: v.levelPath}
        })
      }
      // return
      courseServer.courseBatchUpdate(JSON.stringify(funcConfig)).then(res => {
        const {code, message} = res
        if (code === '0') {
          this.selectData()
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      });
    },
    returnResult (arr) {
      let newArr = []
      for (let i = 0, length = arr.length; i < length; i++) {
        newArr.push(deepCopy(arr[i]))
        if (Array.isArray(arr[i].subList)) newArr = newArr.concat(this.returnResult(arr[i].subList))
      }
      return newArr
    },
    canAddChild(data, node) {
      return node.level && node.level < 5;
    },
    // 处理 tab 切换事件
    onTabChange({tab, prop}) {
      this.professionId = tab
      this.selectData()
      const matchedItem = this.professionData.find(item => item.id === tab);
      if (matchedItem) {
        this.professionName = matchedItem.dictionaryName;
      }
    },
    selectTree () {
      this.dialogtree = true
      this.$nextTick(() => {
        this.$refs.tree.setChecked()
      })
    },
    handleConfirm () {},
    nodeClick (data, node, current) {},
    filterNode (value, data) {
      return !data.delete;
    },
    //子序列增加
    indexData (val) {
      val.forEach((item, index) => {
        item.levelPath = index + 1 + '';
        if (item.subList.length > 0) {
          _indexData(item, item.levelPath);
        }
      });
      function _indexData (item, oldIndex) {
        if (item.subList.length < 0) return;
        if (item.subList.length > 0) {
            item.subList.forEach((Item, i) => {
                Item.levelPath = oldIndex + '.' + (i + 1);
                _indexData(Item, Item.levelPath);
            });
        }
      }
      return val;
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) { // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      // 删除当前关闭的节点
      this.$nextTick(() => {
        this.defaultExpandIds.some((item, i) => {
          if (item === data.id) {
            this.defaultExpandIds.splice(i, 1)
          }
        })
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.index {
  padding: 10px;
  margin: 0 10px;
  background: #fff;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
  // height: 100%;
  max-height: calc(100vh - 70px);
  overflow: auto;
  h2 {
    margin-bottom: 16px;
    span {
      font-size: 14px;
      margin-left: 10px;
      color: #F56C6C;
    }
  }
  .btn-box {
    position: relative;
    .select-ml {
      position: absolute;
      right: 32px;
      top: 0;
      color: #409EFF;
      cursor: pointer;
    }
  }
}
.block {
  overflow: auto;
  margin-top: 20px;
  .custom-tree-node {
    width: 100%;
  }
  .level-path {
    display: inline-block;
    // width: 20px;
    text-align: right;
    padding-right: 5px;
  }
}
.content {
  height: calc(100vh - 172px);
}
/deep/.el-tree {
  height: calc(100vh - 184px);
  overflow: auto;
}
</style>
<style>
.el-tree-node,
.el-tree-node__content {
  margin-bottom: 5px;
  min-height: 50px;
  border-radius: 6px;
}
.el-icon-caret-right{
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/professionChapter.vue